import type { TrainingType } from '@/entities/Training';

export const TRAINING_LIST_TYPE_LABELS: Record<TrainingType, string> = {
  ONBOARDING: 'Onboarding',
  ROLE_CHANGE: 'Alteração de Função',
  SGQ_DOCUMENT_FOCAL: 'Documento do SGQ | Pontual',
  SGQ_DOCUMENT_HOMOLOGATION: 'Documento do SGQ | Fluxo de Homologação',
  OPEN_TRAINING: 'Treinamento Aberto',
};
